export default "__VITE_ASSET__CGz968VC__"